import { type CustomResolversContext } from '../types';

type Args = {
	userId: string;
	maxNumberOfResults: number;
	principalId: string;
	siteId: string;
	sessionId: string;
};

const Containers = async (_: any, args: Args, context: CustomResolversContext, info: any) => {
	const { userId, maxNumberOfResults, principalId, siteId, sessionId } = args;
	return await context
		.fetch(`${context.url.collaborationGraph}/v1/collaborationgraph/user/container`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				context: {
					contextType: 'atlassianDirectory',
					principalId,
					siteId,
					sessionId,
				},
				containerTypes: ['confluenceSpace', 'jiraProject'],
				maxNumberOfResults,
				userId,
				expanded: true,
			}),
		})
		.then((res) => {
			// Matches type of QueryData['Containers'] in
			// packages/embeddable-directory/src/components/CGContainers/ContainersQuery.tsx
			return res.json() as unknown;
		});
};

export default Containers;
